<template>
  <div>
    <div class="recordsdiv">
      <b-row>
        <b-col>
          <div class="form-group">
            <label for="">Client Name</label>
            <input
              class="form-control"
              placeholder="Search Client Name (Contains)"
              type="text"
              v-model="client"
            />
          </div>
        </b-col>
        <b-col class="mtop2">
          <b-button class="btn btn-info" @click="fetchFilterBaaNdas"
            >Fetch Sows</b-button
          >
        </b-col>
      </b-row>
      <br />
      <div v-if="BaaNdaDetails.length > 0" class="row">
        <div
          class="
            col-sm-2
            ml-3
            d-inline-block
            sowcard
            p-0
            mb-3
            border-info
            card
            bg-white
            text-info
          "
          v-bind:key="BaaNda.id"
          v-bind:slug="BaaNda.slug"
          v-for="BaaNda in BaaNdaDetails"
        >
          <div class="lfcard p-1 text-nowrap card-body">
            <div>
              <h6 class="d-inline-block card-title font-weight-bold">
                {{ BaaNda.clientName.substr(0, 22) }}
              </h6>
              <span
                class="badge font-weight-bold"
                v-b-popover.click.top="BaaNdaDetails.clientname"
                v-if="BaaNda.clientName.length > 22"
                >...</span
              >
            </div>
            <div>
              <span style="font-size: 12px">
                Country -
                <span>{{ BaaNda.countrySlug.toUpperCase() }}</span>
              </span>
            </div>
            <div>
              <span
                class="py-1 px-1 d-inline card mr-1"
                style="font-size: 12px"
              >
                <a
                  :href="BaaNda.fileInfo.webURl"
                  target="_blank"
                  class="card-link"
                >
                  <font-awesome-icon
                    class="mx-1 text-info"
                    :icon="['fas', 'file-word']"
                    size="lg"
                  />{{ BaaNda.fileType }}
                </a>
                <font-awesome-icon
                  class="mx-1"
                  :icon="['fas', 'download']"
                  @click="handleDownload(BaaNda.fileInfo)"
                  size="sm"
                />
              </span>
            </div>
            <div class="p-2 card-footer text-muted">
              <small>
                Created On {{ BaaNda.createdAt | formatDateTime }}
                <br />
                By
                {{ BaaNda.createdBy ? BaaNda.createdBy.name : "" }}
              </small>
            </div>
            <!-- <a href="#" class="card-link">SoW Details</a> -->
          </div>
        </div>
      </div>
      <div
        v-if="BaaNdaDetails.length === 0 && isfetched"
        class="w-100 mx-0 my-2 px-2 d-block alert alert-primary"
        role="alert"
      >
        No BaaNdas are generated for the selected filters
      </div>
      <font-awesome-icon
        title="Create New BAA"
        class="text-info addSow ml-2"
        :icon="['fas', 'plus-circle']"
        size="5x"
        @click="c()"
      />
      <b-modal id="bv-modal-example" hide-footer>
        <template v-slot:modal-title>Are you sure?</template>
        <div class="d-block text-center">
          <h4>{{ modalTitle }}</h4>
        </div>
        <div class="d-flex justify-content-center">
          <b-button class="mt-3 mr-1 btn-secondary" @click="no()">No</b-button>
          <b-button class="mt-3 mr-1 btn-info" @click="yes()">Yes</b-button>
        </div>
      </b-modal>
    </div>
    <b-pagination
      v-if="rows > 0"
      v-model="currentPage"
      :total-rows="rows"
      :per-page="pagination.recordsPerPage"
      aria-controls="my-table"
      align="center"
      style="margin-right: 17px"
      @input="fetchResults(currentPage)"
    ></b-pagination>
  </div>
</template>
<script>
import serviceProxy from "../services/index";
import Multiselect from "vue-multiselect";
import _ from "lodash";
import moment from "moment";
export default {
  name: "ViewBAANDAs",
  components: { Multiselect },
  computed: {},
  created() {
    this.FetchBaaNdas(this.pagination);
  },
  methods: {
    getClients(searchText) {
      if (searchText.length > 2) {
        this.isLoading = true;
        serviceProxy.projects
          .getClients(this.$store.getters.token, searchText)
          .then((response) => {
            this.isLoading = false;
            this.clients = response.data.data;
          });
      }
    },

    fetchResults(currentPage) {
      let that = this;
      let pagination = that.pagination;
      pagination.startPageNo = currentPage;
      window.scrollTo(0, 0);
      that.FetchBaaNdas(pagination);
    },
    fetchFilterBaaNdas() {
      let that = this;
      let pagination = that.pagination;
      pagination.filters.name = that.client;
      window.scrollTo(0, 0);
      that.FetchBaaNdas(pagination);
    },
    n(templateDetails, clientName, type) {
      this.selectedtype = type;
      this.selectedtemplateDetails = _.clone(templateDetails);
      this.modalTitle = `Are you sure you want to generate  ${type} template for ${clientName}`;
      this.curaction = "a"; //f-finalize, t-trash, r-redo, d-download
      this.$bvModal.show("bv-modal-example");
    },
    handleDownload(fileInfo) {
      let that = this;
      let FileId = fileInfo.fileId;
      let FileName = fileInfo.fileName;
      that.$root.$emit("progress");
      that.$root.$emit("toast", {
        title: "Downloading  document",
        message: "Downloading  document ",
      });
      serviceProxy.nda
        .DownloadTemplate(this.$store.getters.token, FileId, FileName)
        .then((data) => {
          var fileURL = window.URL.createObjectURL(
            new Blob([data.data], { type: "application/octet-stream" })
          );
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", FileName, FileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: " Document download",
            message: " Document downloaded",
          });
        })
        .catch((e) => {
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "OOPS",
            message: "Error downloading",
          });
        });
    },
    no() {
      this.modalTitle = "";
      this.curaction = "";
      this.selectedtemplateDetails = "";
      this.selectedtype = "";
      this.$bvModal.hide("bv-modal-example");
    },
    yes() {
      switch (this.curaction) {
        case "a":
          let that = this;
          let selectedtype = _.clone(this.selectedtype).toUpperCase();
          let country = _.clone(
            this.selectedtemplateDetails.country
          ).toUpperCase();
          this.$bvModal.hide("bv-modal-example");
          this.modalTitle = "";
          this.curaction = "";
          this.selectedtype = "";
          // For Template
          serviceProxy.template
            .getTemplateWithoutLawfirm(
              this.$store.getters.token,
              selectedtype,
              country
            )
            .then((data) => {
              let response = data.data;
              let templateConfig = _.clone(data.data);
              templateConfig =
                templateConfig.length > 0 ? templateConfig[0] : {};
              that.template = templateConfig.Slug;
              that.title = templateConfig.Title;
              that.selectedDetails = "";
              if (selectedtype === "NDA") {
                that.$store.commit("ndatemplateconfig", templateConfig);
                that.selectedDetails = _.clone(
                  that.selectedtemplateDetails.BaaData
                );
                _.each(
                  that.selectedDetails.PlaceHolders,
                  function (item, index) {
                    item.Name = item.Name.replace(/entity|client/gi, "company");
                  }
                );
              } else if (selectedtype === "BAA") {
                that.$store.commit("baatemplateconfig", templateConfig);
                that.selectedDetails = _.clone(
                  that.selectedtemplateDetails.NdaData
                );
                _.each(
                  that.selectedDetails.PlaceHolders,
                  function (item, index) {
                    if (item.Name == "companyname") {
                      item.Name = "entityname";
                    } else {
                      item.Name = item.Name.replace("company", "client");
                    }
                  }
                );
              }
              let placeHolders = _.clone(
                _.reject(
                  that.selectedDetails.PlaceHolders,
                  (x) =>
                    x.Name === "baadate" ||
                    x.Name === "ndadate" ||
                    x.Name === "clientnameupper"
                )
              );
              let phValues = _.map(placeHolders, (ph) => {
                return {
                  Slug: ph.Name,
                  Value: ph.Value,
                };
              });
              that.$store.commit("placeholders", phValues);
              // For country and documenttype
              this.$store.commit("settings", {
                documenttype: `${selectedtype}`,
                country: country,
                lawfirm: "",
                incidentType: "",
              });
              this.$store.commit("createAgainMode", true);
              this.$router.push({
                path: "choose-document",
              });
            })
            .catch((e) => {
              that.$root.$emit("toast", {
                title: "OOPS",
                message: "Error in fetching the data",
              });
            });

          break;
        default:
          this.$bvModal.hide("bv-modal-example");
          this.modalTitle = "";
          this.curaction = "";
          this.selectedtemplateDetails = "";
          this.selectedtype = "";
          break;
      }
    },
    getTemplate() {},
    c() {
      this.$root.$emit("init");
      this.$router.push({
        path: "choose-document",
      });
    },
    FetchBaaNdas(pagination) {
      let that = this;
      that.$root.$emit("removestage");
      that.$root.$emit("progress");
      that.$root.$emit("toast", {
        title: "Fetching BAA & NDA Data",
        message: "Fetching BAA & NDA Data",
      });
      serviceProxy.baa
        .viewBAA_NDA(that.$store.getters.token, pagination)
        .then((data) => {
          that.pageResponse = data.data.data;
          let response = that.pageResponse;
          this.rows = response.totalRecords;
          that.BaaNdaDetails = response.pageResult;
          that.isfetched = true;
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "BAA & NDA Data Fetched",
            message: "Fetched the BAA & NDA Data",
          });
        })
        .catch((e) => {
          console.log(e);
          that.$root.$emit("done");
        });
    },
  },
  data() {
    return {
      pagination: {
        startPageNo: 1,
        recordsPerPage: 10,
        filters: {},
        sortOrder: {
          columnName: "CreatedAt",
        },
      },
      isfetched: false,
      modalTitle: "",
      BaaNdaDetails: [],
      selectedDetails: "",
      search: "",
      curaction: "",
      selectedtemplateDetails: "",
      selectedtype: "",
      template: "",
      title: "",
      filters: {},
      rows: {},
      pageResponse: [],
      currentPage: 1,
      client: "",
      isLoading: false,
      clients: [],
    };
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.activelf {
  border-top: 3px solid #17a2b8 !important;
  font-weight: bold;
}
.lfcard {
  border-top: 3px solid transparent;
  cursor: pointer;
}
.lawfirmcard {
  width: auto !important;
}
.sowcard {
  width: 265px;
}
.sowcard .card-footer {
  font-size: 14px;
}
.addSow {
  position: fixed;
  bottom: 10px;
  right: 10px;
}
.mtop2{
  margin-top:2%;
}
</style>


